export default `float de(vec3 p){
    float r = 1.; 
    float l = length(p.xz) - r;

    return length(vec2(p.y, l));
  }`